import React from 'react';
import {Switch, useHistory} from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasOrganisation from './ainnotateservice/aidas-organisation';
import AidasCustomer from './ainnotateservice/aidas-customer';
import AidasProject from './ainnotateservice/aidas-project';
import AidasObject from './ainnotateservice/aidas-object';
import AidasVendor from './ainnotateservice/aidas-vendor';
import AidasUser from './ainnotateservice/aidas-user';
import AidasUpload from './ainnotateservice/aidas-upload';
import AidasProperties from './ainnotateservice/aidas-properties';
import AidasProjectProperty from './ainnotateservice/aidas-project-property';
import AidasObjectProperty from './ainnotateservice/aidas-object-property';
import AidasUploadMetaData from './ainnotateservice/aidas-upload-meta-data';
import AidasAuthority from './ainnotateservice/aidas-authority';
import AidasUserAidasObjectMapping from './ainnotateservice/aidas-user-aidas-object-mapping';

/* jhipster-needle-add-route-import - JHipster will add routes here */
const DebugRouter = ({ children }: { children: any }) => {
  const { location } = useHistory()

  /* eslint-disable no-console */
  console.log(
    `Route: ${location.pathname}${location.search}, State: ${JSON.stringify(location.state)}`,
  )
  /* eslint-enable no-console */


  return children
}
const Routes = ({ match }) => (
  <div>
    <DebugRouter>
    <Switch>
      {/* prettier-ignore */}
      <ErrorBoundaryRoute path={`${match.url}aidas-organisation`} component={AidasOrganisation} />
      <ErrorBoundaryRoute path={`${match.url}aidas-customer`} component={AidasCustomer} />
      <ErrorBoundaryRoute path={`${match.url}aidas-project`} component={AidasProject} />
      <ErrorBoundaryRoute path={`${match.url}aidas-object`} component={AidasObject} />
      <ErrorBoundaryRoute path={`${match.url}aidas-vendor`} component={AidasVendor} />
      <ErrorBoundaryRoute path={`${match.url}aidas-user`} component={AidasUser} />
      <ErrorBoundaryRoute path={`${match.url}aidas-upload`} component={AidasUpload} />
      <ErrorBoundaryRoute path={`${match.url}aidas-properties`} component={AidasProperties} />
      <ErrorBoundaryRoute path={`${match.url}aidas-project-property`} component={AidasProjectProperty} />
      <ErrorBoundaryRoute path={`${match.url}aidas-object-property`} component={AidasObjectProperty} />
      <ErrorBoundaryRoute path={`${match.url}aidas-upload-meta-data`} component={AidasUploadMetaData} />
      <ErrorBoundaryRoute path={`${match.url}aidas-authority`} component={AidasAuthority} />
      <ErrorBoundaryRoute path={`${match.url}aidas-user-aidas-object-mapping`} component={AidasUserAidasObjectMapping} />
      {/* jhipster-needle-add-route-path - JHipster will add routes here */}
    </Switch>
    </DebugRouter>
  </div>
);

export default Routes;
